import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import { createCategory, createDoorList, getAllLuggage, getBnbList, uploadFile } from '../../helper/backend_helper';
import InfoTooltip from '../InfoTooltip';
import ScriptSelect from './ScriptSelect';

const AddCategories = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [doorName, setDoorName] = useState('');
  const [bnb, setBnB] = useState([]);
  const [script, setScript] = useState('Script');
  const [value, setValue] = useState('');
  const [description, setDescription] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [emergencyKey, setEmergencyKey] = useState('');
  const [number, setNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [italiandoorName, setItalianDoorName] = useState('');
  const [italianDescription, setItalianDescription] = useState('');
  const [luggageBnB, setLuggageBnB] = useState('');
  const [meters, setMeters] = useState(0);
  const [nearbyBnB, setNearbyBnB] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [luggage, setLuggage] = useState([]);
  async function fetchLuggageData() {
    try {
      const usersResponse = await getAllLuggage();
      const filtredLuggage = usersResponse?.data?.data?.filter((item) => item.bnbType === 'entered');
      setLuggage(filtredLuggage);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchLuggageData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (!formData.profileImage) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Image is required',
        });
        setLoading(false);
        return;
      }
      if (!doorName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Door Name is required',
        });
        setLoading(false);
        return;
      }

      if (!bnb) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'BnB Name is required',
        });
        setLoading(false);
        return;
      }

      if (!script) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Script is required',
        });
        setLoading(false);
        return;
      }

      if (!value) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Value is required',
        });
        setLoading(false);
        return;
      }

      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }
      if (!number) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Number is required',
        });
        setLoading(false);
        return;
      }
      if (!italiandoorName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Door Name is required',
        });
        setLoading(false);
        return;
      }

      if (!italianDescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      const originalFile = formData.profileImage;

      // Log original file size
      console.log('Original file size:', (originalFile.size / 1024).toFixed(2), 'KB');

      // Compression options
      const options = {
        maxSizeMB: 0.3, // Compress to a maximum of 0.5 MB
        maxWidthOrHeight: 800, // Restrict dimensions to 800px
        useWebWorker: true, // Use web worker for performance
        initialQuality: 0.6, // Reduce starting quality to 60%
      };

      // Compress image
      const compressedFile = await imageCompression(originalFile, options);

      // Log compressed file size
      console.log('Compressed file size:', (compressedFile.size / 1024).toFixed(2), 'KB');
      const data = new FormData();
      data.append('file', compressedFile);

      const imageUploadResponse = await uploadFile(data, headers);
      console.log(imageUploadResponse?.data?.data?.fileName);

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed');
      }

      const Categorydata = {
        photo: imageUploadResponse?.data?.data?.fileName,
        description,
        scriptOrCode: script,
        doorName,
        bnb,
        value,
        number,
        deviceId,
        italiandoorName,
        italianDescription,
        emergencyKey,
        doorRadius: meters,
        nearbyBnB,
        adminOnly: isChecked,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createDoorList(Categorydata, Categoryheaders);

      setFormData({
        ...formData,
        profileImage: null,
      });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Door List created successfully',
      });
      setDoorName('');
      setBnB([]);
      setScript('');
      setValue('');
      setDescription('');
      setDeviceId('');
      setItalianDescription('');
      setItalianDoorName('');
      setEmergencyKey('');
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> door list </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Door List</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction={{ xs: 'column', md: 'row' }} useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Door Name <InfoTooltip title="English name of this door or access point, shown to guests in their check-in instructions." /></FormLabel>
              <TextField
                label="Enter Door Name"
                id="outlined-size-small"
                value={doorName}
                onChange={(e) => setDoorName(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Italian Door Name <InfoTooltip title="Italian name of this door, shown to guests who view their check-in instructions in Italian." /></FormLabel>
              <TextField
                label="Enter Italian Door Name"
                id="outlined-size-small"
                value={italiandoorName}
                onChange={(e) => setItalianDoorName(e.target.value)}
              />
            </Stack>
            {/* <Stack>
              <FormLabel sx={{ mb: 1 }}>Script</FormLabel>
              <TextField
                label="Enter Script"
                id="outlined-size-small"
                value={script}
                onChange={(e) => setScript(e.target.value)}
              />
            </Stack> */}

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>Script <InfoTooltip title="How this door is opened: a written script the guest follows, a physical lockbox, or a script combined with a doorbell." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={script}
                  // label="BnB"
                  onChange={(e) => setScript(e.target.value)}
                >
                  <MenuItem value="Script">Script</MenuItem>
                  <MenuItem value="Lockbox">Lockbox</MenuItem>
                  <MenuItem value="Script + Doorbell">Script + Doorbell</MenuItem>
                  {/* {users?.map((user) => (
                    <MenuItem key={user._id} value={user.BnBShortName}>
                      {user.BnBShortName}
                    </MenuItem>
                  ))} */}
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>
                {script === 'Lockbox' ? 'Keybox code' : 'Script'}{' '}
                <InfoTooltip
                  title={
                    script === 'Lockbox'
                      ? 'The physical lockbox PIN guests use to open this door.'
                      : 'The saved script that opens this door. Pick one from the list, or click + to add a new one (paste the script and give it a name). Secrets stay as placeholders and are filled in from Shelly Settings.'
                  }
                />
              </FormLabel>
              {script === 'Lockbox' ? (
                <TextField
                  label="Enter Keybox code"
                  id="outlined-size-small"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />
              ) : (
                <ScriptSelect value={value} onChange={setValue} />
              )}
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Device ID / Phone Number <InfoTooltip title="Identifier of the smart lock or intercom device, or the phone number the open-door script dials." /></FormLabel>
              <TextField
                label="Enter Device ID / Phone Number"
                id="outlined-size-small"
                value={deviceId}
                onChange={(e) => setDeviceId(e.target.value)}
              />
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Which properties this door belongs to. Guests of these BnBs will see these access instructions." /></FormLabel>
                <Select
                  labelId="demo-multi-select-label"
                  id="demo-multi-select"
                  multiple
                  value={bnb} // This will be an array
                  onChange={(e) => setBnB(e.target.value)}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {users?.map((user) => (
                    <MenuItem key={user._id} value={user.BnBShortName}>
                      <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                      {user.BnBShortName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Sequence Number <InfoTooltip title="Order in which this door appears in the guest's step-by-step access instructions (lower numbers come first)." /></FormLabel>
              <TextField
                type="number"
                label="Enter Sequence Number"
                id="outlined-size-small"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Emergency Key <InfoTooltip title="Backup key or code for this door, used by staff if the normal access method fails." /></FormLabel>
              <TextField
                label="Enter Emergency Key"
                id="outlined-size-small"
                value={emergencyKey}
                onChange={(e) => setEmergencyKey(e.target.value)}
              />
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>BnB Radius (meters) <InfoTooltip title="Distance in metres from the property within which the guest must be to unlock this door (0 disables the geofence)." /></FormLabel>
              <TextField
                type="number"
                label="Enter BnB Radius (meters)"
                id="outlined-size-small"
                value={meters}
                onChange={(e) => setMeters(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>Near by Door <InfoTooltip title="Whether this door is treated as nearby for grouping access steps; leave on Default unless you need to force Yes or No." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={nearbyBnB}
                  // label="BnB"
                  onChange={(e) => setNearbyBnB(e.target.value)}
                >
                  <MenuItem value="default">Default</MenuItem>
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Description <InfoTooltip title="English step-by-step explanation of how to find and open this door, shown to guests during check-in." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Description"
                id="outlined-size-small"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Italian Description <InfoTooltip title="Italian version of the open-door instructions, shown to guests browsing in Italian." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Italian Description"
                id="outlined-size-small"
                value={italianDescription}
                onChange={(e) => setItalianDescription(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack sx={{ marginTop: 2, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Admin Only:
            </Typography>
            <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {formData.profileImage && (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddCategories;
